import { gqlMutate } from '@hapana/shared/web/services/requests.service'

import * as mutations from './graphql/equipment-assignment.mutations'
import * as addonInvoiceMutations from './graphql/addon-invoice.mutations'

export const createEquipmentAssignment = ({
  siteId,
  clientId,
  delayMinutes,
  equipmentId,
  isOverride,
  timerMinutes,
  checkInId,
  siteSessionTypeId,
}) =>
  gqlMutate({
    mutation: mutations.createEquipmentAssignment,
    variables: {
      input: {
        siteId,
        clientId,
        delayMinutes,
        equipmentId,
        isOverride,
        timerMinutes,
        ...(checkInId && { checkInId }),
        ...(siteSessionTypeId && { siteSessionTypeId }),
      },
    },
  })

export const createAddonInvoice = ({ siteId, clientId, equipmentId, siteSessionTypeId }) =>
  gqlMutate({
    mutation: addonInvoiceMutations.createAddonInvoice,
    variables: {
      input: {
        siteId,
        clientId,
        equipmentId,
        ...(siteSessionTypeId && { siteSessionTypeId }),
      },
    },
  })

export const cancelEquipmentAssignment = ({ assignmentId }) =>
  gqlMutate({
    mutation: mutations.cancelEquipmentAssignment,
    variables: { assignmentId },
  })
